export const FETCH_BRANDS = "/administration/fetch_brands/";
export const FETCH_ADMINISTRATOR_LEVELS = "/administration/fetch_administrator_levels/";
export const CREATE_ADMINISTRATOR = "/administration/create_administrator/";
export const UPDATE_ADMINISTRATOR = "/administration/update_administrator/";
export const DELETE_ADMINISTRATOR = "/administration/delete_administrator/";
export const ADD_BRAND = "/administration/create_brand/";
export const UPDATE_BRAND = "/administration/update_brand/";
